import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import Button from '../../../../components/common/Button';
import Card from '../../../../components/common/Card';

export default function SignupSuccess({ organizationName, onFinish }) {
  return (
    <div className="text-center space-y-6">
      <div className="flex justify-center">
        <div className="rounded-full bg-green-100 p-4">
          <CheckCircle2 className="h-12 w-12 text-green-600" />
        </div>
      </div>
      
      <h2 className="text-2xl font-bold text-navy">
        Welcome to Stickr, {organizationName}!
      </h2>
      
      <p className="text-navy/70 max-w-md mx-auto">
        Your account has been successfully created and your subscription is active.
        You're all set to start using Stickr's secure email verification.
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
        {nextSteps.map((step, index) => (
          <Card key={index} className="p-4 text-left">
            <div className="flex items-center mb-2">
              <div className="bg-primary/10 rounded-full w-6 h-6 flex items-center justify-center mr-2">
                <span className="text-primary font-medium">{index + 1}</span>
              </div>
              <h3 className="font-medium text-navy">{step.title}</h3>
            </div>
            <p className="text-sm text-navy/70">{step.description}</p>
          </Card>
        ))}
      </div>
      
      <div className="mt-8">
        <Button onClick={onFinish} className="px-6">
          Go to Dashboard <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

const nextSteps = [
  {
    title: 'Set Up Your Domain',
    description: 'Verify your domain to start securing your email communications.'
  },
  {
    title: 'Invite Your Team',
    description: 'Add team members to your Stickr workspace.'
  },
  {
    title: 'Configure Security',
    description: 'Set up additional security features for your organization.'
  }
]; 